import React from 'react';
import VehicleEntityGridPage from './VehicleEntityGridPage';
import { VEHICLE_MAINTENANCE } from './vehicleEntityConfigs';

const VehicleMaintenance = () => <VehicleEntityGridPage config={VEHICLE_MAINTENANCE} />;

export default VehicleMaintenance;
